/**
 * Hoeveel voorstellen er wachten, en dat getal bijhouden terwijl je werkt.
 *
 * **DIT BESTAAT OMDAT DE TELLING KAPOT WAS EN NIET OMDAT ER IETS BIJ MOEST.**
 * Franks bevinding van 24 augustus 2026: de telling in de zijbalk werd EEN KEER
 * opgehaald, bij het openen van het scherm, in een `useEffect` met een lege
 * afhankelijkheidslijst. Legt de klok er om kwart over drie iets bij, dan bleef
 * dat getal op de oude stand staan tot de app opnieuw werd geopend. Een telling
 * die nooit ververst is geen bescheiden telling, die is stuk.
 *
 * **WANNEER ER OPNIEUW WORDT GEKEKEN, en waarom precies dan.**
 *
 * 1. **Bij het openen**, zoals altijd al.
 * 2. **Zodra het venster weer aandacht krijgt.** Dat is het moment waarop je
 *    ernaar kijkt, en dus het enige moment waarop een verouderd getal je echt
 *    misleidt. Het kost niets als je niet kijkt.
 * 3. **Elke vijf minuten**, voor het geval het venster de hele tijd voor staat.
 *    De klok oogst elk kwartier, dus vaker kijken levert per definitie zelden
 *    iets nieuws op.
 *
 * **WAAROM NIET ELKE PAAR SECONDEN.** Huisregel: een meting is geen gratis
 * handeling. Deze route raakt geen begrenzing, want hij loopt naar de eigen
 * machine, maar een lus die twintig keer per minuut vraagt is nog steeds een lus
 * die iemand op een dag moet uitleggen.
 */

const VIJF_MINUTEN = 5 * 60 * 1000;

export const TUSSEN_METINGEN_MS = VIJF_MINUTEN;

/**
 * Zet het bijhouden aan. Geeft een functie terug die alles weer opruimt.
 *
 * `haal` doet de meting en `zet` krijgt de uitkomst. Allebei meegegeven zodat
 * dit los van axios en los van React te toetsen is: wat hier wordt bewaakt is
 * WANNEER er wordt gekeken, en dat is iets anders dan wat er wordt opgehaald.
 */
export function houdBij({ haal, zet, venster = typeof window !== "undefined" ? window : null,
                          document: doc = typeof document !== "undefined" ? document : null,
                          interval = TUSSEN_METINGEN_MS }) {
  let gestopt = false;

  const meet = async () => {
    try {
      const aantal = await haal();
      if (!gestopt) zet(aantal);
    } catch {
      // Stil. Een oudere backend heeft deze route niet, en een rood bericht
      // over een telling die niemand heeft gevraagd is ruis.
      if (!gestopt) zet(0);
    }
  };

  const bijAandacht = () => {
    // `visibilitychange` vuurt OOK bij het wegklikken; alleen bij terugkomst
    // is er iets te meten.
    if (!doc || doc.visibilityState !== "hidden") meet();
  };

  meet();
  const tik = venster ? venster.setInterval(meet, interval) : null;
  if (doc) doc.addEventListener("visibilitychange", bijAandacht);
  if (venster) venster.addEventListener("focus", bijAandacht);

  return () => {
    gestopt = true;
    if (tik !== null && venster) venster.clearInterval(tik);
    if (doc) doc.removeEventListener("visibilitychange", bijAandacht);
    if (venster) venster.removeEventListener("focus", bijAandacht);
  };
}
